var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import BookmarkListMenu from "backpack-ui/dist/components/bookmarkListMenu";
import BookmarkListMenuOption from "backpack-ui/dist/components/bookmarkListMenu/option";
import { Share } from "backpack-ui/dist/components/icon";
import ShareSettings from "backpack-ui/dist/components/shareMenu/shareSettings";
import * as cn from "classnames";
import * as React from "react";
import { ButtonOutline } from "./buttonOutline";
var ButtonShare = /** @class */ (function (_super) {
    __extends(ButtonShare, _super);
    function ButtonShare() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.shareContent = {
            text: "",
            twitterContent: "",
            url: "",
            via: "",
        };
        return _this;
    }
    ButtonShare.prototype.componentDidMount = function () {
        var _a = this.props, shareText = _a.shareText, getPoiUrl = _a.getPoiUrl;
        this.shareContent = {
            text: shareText,
            twitterContent: "Check out the " + shareText + " via @lonelyplanet https://www.lonelyplanet.com" + getPoiUrl(),
            url: "https://www.lonelyplanet.com" + getPoiUrl(),
            via: "lonelyplanet",
        };
    };
    ButtonShare.prototype.render = function () {
        var _this = this;
        var _a = this.props, className = _a.className, showToast = _a.showToast;
        return (React.createElement(BookmarkListMenu, { iconName: "Share", iconLabel: "Share", button: React.createElement(ButtonOutline, { className: cn(className) },
                React.createElement(Share, null),
                " Share") },
            React.createElement(ShareSettings, { shareContent: this.shareContent, handleClipboardSuccess: function () { return showToast("Sucessfully copied to clipboard"); }, handleClipboardError: function () { return showToast("There was an error, please copy URL manually", "error"); } }, function (shareActions, __, ClipboardWrapper) { return (React.createElement("span", null,
                React.createElement(BookmarkListMenuOption, { onClick: function () { return shareActions.twitter(); } }, "Share on Twitter"),
                React.createElement(BookmarkListMenuOption, { onClick: function () { return shareActions.facebook(); } }, "Share on Facebook"),
                React.createElement(ClipboardWrapper, { text: _this.shareContent.url },
                    React.createElement(BookmarkListMenuOption, { onClick: function () { return null; } }, "Copy link")))); })));
    };
    return ButtonShare;
}(React.Component));
export { ButtonShare };



//////////////////
// WEBPACK FOOTER
// ./app/modules/pois/components/button/buttonShare.tsx
// module id = oSA5
// module chunks = 2